module.exports = __webpack_public_path__ + "static/46invgde-3b0a00d714dbf74546c433299b5789e5.gif";